import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {useSelector, useDispatch} from 'react-redux'
import { getChildKontoUsers } from 'actions'
import { isEmpty, isUndefined } from 'lodash'
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

function MinaChildKontoUser(props) {
    const dispatch = useDispatch()
    const classes = useStyles();
    const Afid = useSelector(state => state.auth.authUser.user_Afid)
    const userid = useSelector(state => state.auth.authUser.user_id)
    const ChildKontoUsers = useSelector(state => state.accountsData.ChildKontoUsers)
    const [Orderuserid, setOrderuserid] = React.useState(props.Ansvarig);
    React.useEffect(()=>{
        setOrderuserid(props.Ansvarig)
    },[props.Ansvarig])
    React.useEffect(()=>{
        dispatch(getChildKontoUsers(Afid,userid,props.OrderAfid))
    },[props.OrderAfid])
    React.useEffect(()=>{
        if(isUndefined(props.OrderAfid)){
            dispatch(getChildKontoUsers(Afid,userid,Afid))
        }        
    },[])
    /*React.useEffect(()=>{
        if(isEmpty(ChildKontoUsers)){
            props.onChangeOOuser(userid)
        }
        else{
           props.onChangeOOuser(ChildKontoUsers[0].id)
        }
    },[ChildKontoUsers])*/
    console.log(ChildKontoUsers,"ChildKontoUsers")
    console.log(props.Ansvarig,"handleChange2")
    return (
        <form className={classes.root}>
        <div>
            <TextField
                select
                label={<IntlMessages id="appKontoModule.Owner"/>}
                variant="outlined"
                name="Ansvarig"
                size="small"
                value={Orderuserid}
                fullWidth
                onChange={props.onChangenOrderUser}
                SelectProps={{
                    native: true,
                }}
                InputLabelProps={{
                    shrink: true,
                  }}
            > 
           <option key={0} value={0}><IntlMessages id="Choose"/></option>            
            {
                isEmpty(ChildKontoUsers)?"":
                ChildKontoUsers.filter(item=> !isEmpty(item.UserEmail)).map((option) => (
                    <option key={option.id} value={option.id}>
                       {option.FirstName} {isEmpty(option.LastName)?"":option.LastName}
                    </option>
                ))}
            </TextField>
        </div>
    </form>
    );
}

export default MinaChildKontoUser;